/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WaterConsumptionDto } from '../../models/water-consumption-dto';

export interface GetWaterConsumptionPerformace$Params {
  deviceId: number;
  harvestId: number;
  fillMissingDates?: boolean;
}

export function getWaterConsumptionPerformace(http: HttpClient, rootUrl: string, params: GetWaterConsumptionPerformace$Params, context?: HttpContext): Observable<StrictHttpResponse<WaterConsumptionDto>> {
  const rb = new RequestBuilder(rootUrl, getWaterConsumptionPerformace.PATH, 'get');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.path('harvestId', params.harvestId, {});
    rb.query('fillMissingDates', params.fillMissingDates, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WaterConsumptionDto>;
    })
  );
}

getWaterConsumptionPerformace.PATH = '/api/harvests/waterConsumptionPerformace/{harvestId}/{deviceId}';
